import React, { useContext, useState,useEffect } from 'react';
import { Row, Col, Form, Tabs, Modal, message } from 'antd';
import {
  Button,
  Input
} from 'components';


import ArrowRight from '../../../../assests/icons/arrow-right';

import '../../../Messages/message-steps/steps.less';
import '../create-title-step-1.less';
import SelectDatePicker from '../../../../components/Select/datepicker';
import { DimensionsContext } from '../../../../context/dimensions.context';

import { useUser } from 'context/user.context';
import * as alphaService from '../../../../services/alpha.service';
import { customMessages } from 'utils';
import moment from 'moment';
import  titleReducer  from 'reducers/title.reducer';
import { useSelector, useDispatch } from 'react-redux';
import MessagesSummary from './partials/messages-summary';

import {turkishToUpper} from 'utils/utility-functions';


const IdentityTitle = (props) => {
 const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { isPc } = useContext(DimensionsContext);
  const [birthDate, setBirthDate] = useState('');
  const {newFirm} = props;
   const [valid, setValid] = useState(false);
  const [currentData, setCurrentData] = useState(props.firmData);


 const onLoginFormSubmit = (values) => {
     onNext(values);
  };
  const onValuesChange = () => {
    
    setTimeout(() => {
      form
      .validateFields()
      .then((values) => {
        if (!birthDate)
        {
          setValid(false);
        }
        else
        {
          setValid(true);
        }
      })
      .catch((errorInfo) => {
        setValid(false);
      });
      // let inputs = form.getFieldsError();

      // for (var i = 0; i < inputs.length; i++) {
      //   let formItemName = inputs[i]['name'][0];
      //   if (checkError(formItemName)) {
      //     setValid(true);
      //   } else {
      //     setValid(false);
      //     break;
      //   }
      // }
    }, 10);
  };

 function onNext (values) 
  {
    if (newFirm)
    {
      var newData= {};
      newData.dogumTarihi=moment(birthDate).format('DD.MM.YYYY');;
      newData.name=values.name;
      newData.surname=values.surname;
      newData.cuzdanSeriNo=values.cuzdanSeriNo;  
      newData.tckNo=values.tckNo;
      alphaService.checkMernis(newData)
      .then((result)=> 
      {
        let {user} = currentData;
        user ={...newData, user};
        currentData.user=user;
        props.onFirmUpdate(currentData);
        props.updateCurrent(1);
      }
       
      )
      .catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
        return;
      });
    }
    else
    {
      props.updateCurrent(1);
    }
  }

  const checkError = (fieldName) => {
    if (
      form.isFieldTouched(fieldName) &&
      form.getFieldError(fieldName).length === 0
    ) {
      return true;
    }
  };

  const onValueChange = (date, dateString) => {
    if (date)
  {
      
    setBirthDate(moment(date,'DD.MM.YYYY'));
    form
    .validateFields()
    .then((values) => {
      if (!date)
      {
        setValid(false);
      }
      else
      {
        setValid(true);
      }
    })
    .catch((errorInfo) => {
      setValid(false);
    });
  }
  else{
    setBirthDate(null);
    setValid(false);
  }
  };

  useEffect(() => {
    if (currentData.user)
    {
        form.setFieldsValue({
            name: currentData.user.name,
            surname:currentData.user.surname,
            cuzdanSeriNo:currentData.user.cuzdanSeriNo,
            tckNo:currentData.user.tckNo
          });        
        setBirthDate(moment(currentData.user.dogumTarihi,'DD.MM.YYYY'));
        setValid(true);
      }
    }, [currentData.user]);

  return (

  
        <Form
          form={form}
          onFinish={onLoginFormSubmit}
          onValuesChange={onValuesChange}
          name="create-title-step-1"
        >
          <div className="step-transitions">
            <div className="container">
              <div className="step-transitions_left"></div>
             
                <div className="step-transitions__right">
                  <Button
                    type="primary"
                    shape="round"
                    htmlType="submit"
                    className="ant-btn--icon"
                    disabled={!valid}
                  >
                    Şirket Bilgileri
                    <ArrowRight />
                  </Button>
                </div>
            </div>
          </div>
          <div className="page-content">
            <div className="container">
              <Row>
                <Col md={24} lg={16} xl={16} span={24}>
                  <div>
                    <div>
                      <h3 className="box__title">Kimlik Bilgileri</h3>
                      <Row gutter={20}>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]} 
                            name="name"  
                            messageVariables={{ label: 'name' }}
                            getValueFromEvent={(e) => {
                              return  turkishToUpper(e.target.value || '')
                            }}
                          >
                            <Input type="text" label="Adınız" name="name" 
                            style={{ textTransform: 'uppercase'}}
                             disabled={!newFirm}/>
                          </Form.Item>
                        </Col>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="surname"
                            messageVariables={{ label: 'surname' }}
                            getValueFromEvent={(e) => {
                              return  turkishToUpper(e.target.value || '')
                            }}
                          >
                            <Input
                              type="text"  disabled={!newFirm}  style={{ textTransform: 'uppercase'}}
                              label="Soyadınız"
                              name="surname" 
                            />
                          </Form.Item>
                        </Col>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true },
                              {
                                validator(_, value) {
                                  if (!value || value.length === 11) {
                                    
                                    return Promise.resolve();
                                  }
                                  return Promise.reject('Please enter 11 digit Number!');
                                },
                              },]}
                            name="tckNo"    
                            messageVariables={{ label: 'tckNo' }}
                          >
                            <Input
                              type="number" maxLength={11}
                              label="TC Kimlik Numaranız"
                              name="tckNo"  disabled={!newFirm}
                            />
                          </Form.Item>
                        </Col>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          <Form.Item
                            rules={[{ required: true }]}
                            name="cuzdanSeriNo" 
                            messageVariables={{ label: 'cuzdanSeriNo' }}
                            getValueFromEvent={(e) => {
                              return  turkishToUpper(e.target.value || '')
                            }}
                          >
                            <Input
                              type="text" disabled={!newFirm} style={{ textTransform: 'uppercase'}}
                              label="Nüfus Cüzdanı Seri No"
                              name="cuzdanSeriNo"
                            />
                          </Form.Item>
                        </Col>
                        <Col sm={12} md={12} lg={12} xl={12} span={24}>
                          
                            <SelectDatePicker value={birthDate}
                             name="dogumTarihi" 
                             onChange={ onValueChange} 
                             format={"DD.MM.YYYY"} 
                             small label="Doğum Tarihiniz"  
                             disabled={!newFirm}/>
                          
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col
                  sm={24}
                  md={24}
                  lg={{ span: 6, offset: 2 }}
                  xl={{ span: 6, offset: 2 }}
                  span={24}
                >
                  <div>
                    <MessagesSummary
                      typeV2
                      identityInfo={
                        <>
                        {currentData.user && 
                           <>{currentData.user.name} {currentData.user.surname}  <br /> {currentData.user.tckNo} <br />  {currentData.user.cuzdanSeriNo} <br />
                          </>
                        }
                        </>
                      }
                      companyInfo=""
                      necessaryInfo=""
                    />
                  </div>
                </Col>
              </Row>
            </div>
            {/* {!isPc ? (
              <div className="step-transitions__right">
                <Button
                  type="primary"
                  shape="round"
                  htmlType="submit" onClick={() => onNext()}
                  className="ant-btn--icon"
                >
                  Şirket Bilgileri
                  <ArrowRight />
                </Button>
              </div>
            ) : null} */}
          </div>
        </Form>
  );
};

export default IdentityTitle;
